module.exports = "\r\n<div id=\"mainC\">\r\n    <div class=\"message\">\r\n      <h1>404</h1>\r\n      <h3>the page you seek does not exist</h3>\r\n    </div>\r\n    <div class=\"footer\">\r\n      <a href=\"javascript:history.back()\" title=\"back\" target=\"_blank\">back <span></span></a>\r\n     \r\n    </div>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main